import { mapGetters } from 'vuex'
import { queryFiledLanguageList } from '@api/api'
import { getLangFieldDetail, setInputParams, checkField, getLanguageField, openLangInputModal, setLangInputParams } from '@/utils/langUtils'

export const FormItemMixin = {
  inject: ['langFieldData', 'getForm', 'getDetailData'],
  data() {
    return {
      itemAttrs: this.formitem.itemAttrs,
      placeholder: this.formitem.placeholder,
      formitemAttrs: this.formitem.formitemAttrs,
      colAttrs: this.formitem.colAttrs,
      popContainerString: '.jeecg-online-modal .ant-modal-content'
    }
  },
  props: {
    formitem: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    isTabProp: {
      type: Boolean,
      default: false,
      required: false
    },
    tabDataIndex: {
      type: Number,
      default: 0,
      required: false
    },
    tabKey: {
      type: String,
      default: '',
      required: false
    },
    otherLabel: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    widgetAttrs() {
      return this.formitem.widgetAttrs
    },
    label() {
      if (!this.otherLabel || this.otherLabel.length == 0) {
        return this.formitem.label
      } else {
        return this.otherLabel
      }
    },
    // label的多语言key
    labelLangKey() {
      if (!this.otherLabel || this.otherLabel.length == 0) {
        return this.formitem.labelLanguageKey
      } else {
        return this.otherLabel
      }
    },
    // 数据多语言字段数组，一维数组
    inputLangField() {
      return this.langFieldData()
    },
    // 表单组件
    formRef() {
      return this.getForm()
    },
    // 详情数据
    detailData() {
      return this.getDetailData()
    }
  },
  methods: {
    ...mapGetters(['langFieldMap']),
    // 判断是否为数据多语言字段，是则readonly设为true
    checkField(field) {
      if(!field) return false
      return this.inputLangField.includes(field)
    },
    // 打开数据多语言录入模态框
    async openLang(field) {
      if (!this.checkField(field)) return
      let { tableName } = this.formitem
      // 根据业务id和表名、字段获取本地缓存这种的多语言数组
      let arr = setInputParams({ tableName, field, id: this.detailData.id })
      console.log(arr, '自我编辑获取')
      let fieldObj = {
        field,
        detail: arr,
        id: this.detailData.id,
        require: true,
        tableName
      }
      // 详情才会调接口获取
      if (this.detailData.id) {
        // 判断本地缓存中如果没有则调用接口
        if (!arr || !arr.length) {
          let res = await getLangFieldDetail({field, id: this.detailData.id, tableName})
          fieldObj.detail = res
        }
      }
      openLangInputModal(fieldObj, (data, content) => this.langInputSubmit(data, content))
    },
    // 数据多语言录入数据后回调
    langInputSubmit({ field, value }) {
      // 设置表单值回填
      this.formRef.setFieldsValue({
        [ field ]: value
      })
    },
    getVdecorator() {
      let id = this.tabKey + '[' + this.tabDataIndex + '].' + this.formitem.key
      console.log(this.formitem.fieldDecoratorOptions)
      return [id, { rules: [{ required: true, message: 'Please select your country!' }] }]
    },
    getPopupContainer(node) {
      return node.parentNode
    },
    getModalAsContainer(node) {
      return document.querySelector(this.popContainerString)
    }
  },
  mounted() {
    //console.log(this.formitem)
  }

}